export class SkipButtonController {
    constructor({ button, mainContentSelector, isWixSite }) {
        this.buttonClickHandler = () => {
            var _a;
            if (this.mainContentSelector) {
                (_a = document.querySelector(this.mainContentSelector)) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        this.tabClickHandler = (event) => {
            const isTabPressed = event.key === 'Tab' || event.keyCode === 9;
            if (isTabPressed) {
                this.mainContentSelector = this.getWixSiteMainContentSelector();
                if (this.mainContentSelector) {
                    this.makeButtonFocusable();
                    this.removeWixSiteSkipButton();
                }
            }
        };
        this.getWixSiteMainContentSelector = () => {
            var _a, _b;
            return (_b = (_a = window.wixEmbedsAPI) === null || _a === void 0 ? void 0 : _a.getMainContentElementSelector) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.removeWixSiteSkipButton = () => {
            var _a;
            if ((_a = window.wixEmbedsAPI) === null || _a === void 0 ? void 0 : _a.getSkipToMainContentButtonSelector) {
                const editorSkipButton = document.querySelector(window.wixEmbedsAPI.getSkipToMainContentButtonSelector());
                if (editorSkipButton) {
                    editorSkipButton.remove();
                }
            }
        };
        this.button = button;
        this.mainContentSelector = mainContentSelector;
        this.isWixSite = isWixSite;
    }
    init() {
        if (this.mainContentSelector) {
            this.makeButtonFocusable();
        }
        else if (this.isWixSite) {
            document.addEventListener('keydown', this.tabClickHandler);
        }
        this.button.addEventListener('click', this.buttonClickHandler);
    }
    makeButtonFocusable() {
        this.button.tabIndex = 0;
    }
}
//# sourceMappingURL=SkipButtonController.js.map